import React from 'react';

import {connect, actions} from 'mirrorx';

import Combokeys from 'combokeys';
import globalBind from 'combokeys/plugins/global-bind';

import Pages from '../enums/pages';
import SaveCurrentFileModal from '../components/save-current-file-modal';

import DropboxIO from './io';

class KeyboardShortcuts extends React.Component {

	constructor() {
		super();
		this.io = null;
		this.createNewFile = this.createNewFile.bind(this);
		this.saveAndNewFileEvent = this.saveAndNewFileEvent.bind(this);
		this.saveContent = this.saveContent.bind(this);
		this.saveContentAs = this.saveContentAs.bind(this);
		this.openContent = this.openContent.bind(this);
	}

	saveContent(e) {
		if (e && e.preventDefault) {
	        e.preventDefault();
	    } else if (e) {
	        // internet explorer
	        e.returnValue = false;
	    }

	    this.io.saveFile().then(alreadySaved => {
	    	if (alreadySaved) {
	    		actions.autosave.addRecentPath({
	    			name: this.props.editor.file.name,
	    			path: this.props.editor.file.path,
	    			service: this.props.editor.file.service
	    		});
	    	}
	    })
	    
	}

	saveAndNewFileEvent(e) {
		this.io.saveFile(e).then(alreadySaved => {
			if (alreadySaved) {
				this.io.newFile();
			}
		})
	}

	createNewFile(e) {
		if (e && e.preventDefault) {
	        e.preventDefault();
	    } else if (e) {
	        // internet explorer
	        e.returnValue = false;
	    }
		if (!this.props.editor.isDirty) {
			this.io.newFile();
		}
		else {
			this.refs.saveModal.activateModal();
		}
	}

	saveContentAs(e) {
		if (e && e.preventDefault) {
	        e.preventDefault();
	    } else if (e) {
	        // internet explorer
	        e.returnValue = false;
	    }

	    actions.layout.setPage(Pages.SAVE_FILE);

	    return false;
	}

	openContent(e) {
		if (e.preventDefault) {
	        e.preventDefault();
	    } else {
	        // internet explorer
	        e.returnValue = false;
	    }
	    this.io.openFile();
	    return false;

	}
	componentDidMount() {
		this.io = new DropboxIO(this.props);
		this.combokeys = new Combokeys(document);
		globalBind(this.combokeys);

		this.combokeys.bindGlobal(['command+s', 'ctrl+s', 'alt+s'], this.saveContent);
		this.combokeys.bindGlobal(['alt+n'], this.createNewFile);
		this.combokeys.bindGlobal(['command+shift+s', 'ctrl+shift+s', 'alt+shift+s'], this.saveContentAs);
		this.combokeys.bindGlobal(['command+o', 'ctrl+o', 'alt+o'], this.openContent);
	}

	componentWillUnmount() {
	}

	componentWillReceiveProps(nextProps) {
		if (this.io) {
			this.io.setProps(nextProps);
		}
	}

	render() {
		
		return <div>
			
			<SaveCurrentFileModal ref='saveModal' 
				name={this.props.editor.file.name} 
				path={this.props.editor.file.path} 
				service={this.props.editor.file.service}
				onClick={this.saveAndNewFileEvent}
				onCancel={actions.editor.reset}/>
		</div>
	}

}


export default connect(state => {
  return {layout: state.layout,
  	editor: state.editor,
  	services: state.services}
})(KeyboardShortcuts)


// WEBPACK FOOTER //
// ./src/singletons/keyboard.js